import {atcStates} from '../atc-routes';
import {SIZE_MEDIUM} from '../../common/modal/modal-service';
import {tripStates} from '../../trip/trip-routes';

export default function AtcCheckResultController(
    $scope,
    $state,
    $stateParams,
    atcFlightsFactory,
    atcFlightsService,
    atcCalendarService,
    modalService,
    l10nService,
    $sce,
) {
    'ngInject';

    const vm = this;
    const invalidModifiedSegments = modalService.createInfoModal(
        l10nService.localize('Invalid operation'),
        l10nService.localize('You must modify the current values to be able to search for flights.'),
        SIZE_MEDIUM
    );

    const invalidFlightSegments = modalService.createInfoModal(
        l10nService.localize('Invalid operation'),
        l10nService.localize('You can only modify up to three flights by this way. Please contact your travel advisor for other options.'),
        SIZE_MEDIUM
    );

    Object.assign(vm, {
        $onInit,
        findFlights,
        cancel,
    });

    Object.assign($scope, {
        getPreviousSegment,
        findFlights,
        cancel,
        showFlexibleCondition,
        showBaggageFilter,
        showEligibilityInfo,
        getMessage,
    });

    $scope.isCurrentDay = atcFlightsService.isCurrentDay;
    $scope.isValidPnr = false;
    $scope.isBusy = true;
    $scope.tooltipTemplate = $sce.trustAsResourceUrl('app/modules/atc/templates/atc-check-elegibility-tooltip.html');
    $scope.luggageOptions = [
        {text: 'Luggage irrelevant', value: 'null'},
        {text: 'Need luggage', value: 'true'},
        {text: 'Don\'t need luggage', value: 'false'},
    ];

    function $onInit() {
        atcFlightsFactory.params.reset();
        atcFlightsFactory.checkEligibility(
            atcFlightsService.getCheckResultRequest(),
            $scope.options.cabinClasses
        ).finally(function() {
            $scope.isValidPnr = (atcFlightsFactory.params.TicketSearchSegments && atcFlightsFactory.params.TicketSearchSegments.length > 0);
            $scope.isBusy = false;
        });
    }

    function getPreviousSegment(index) {
        return index === 0
            ? null
            : $scope.params.TicketSearchSegments[index - 1];
    }

    function findFlights() {
        const request = atcFlightsFactory.params.getSearchRequestParams();

        if (request.Segments.length > 3) {
            invalidFlightSegments();
            return;
        }

        if (request.Segments.filter((seg) => seg.isChanged).length > 0) {
            if (showFlexibleCondition() && atcFlightsFactory.params.FlexibleCondition) {
                atcCalendarService.cleanCalendarSearchConditions();
                $state.go(atcStates.CALENDAR_VIEW, {
                    searchConditions: request,
                });
            } else {
                $state.go(atcStates.FLIGHTS_VIEW, {
                    searchConditions: request,
                });
            }
        } else {
            invalidModifiedSegments();
        }
    }

    function cancel() {
        //if (!$scope.params.TripId) {
        if (!$scope.params.FromTripDetails) {
            $state.go(atcStates.CHECK);
        } else {
            $state.go(tripStates.TRIP_DETAILS, {
                id: $scope.params.TripId,
                department: $scope.params.DepartmentId,
            });
        }
    }

    function showFlexibleCondition() {
        return $scope.params.TicketSearchSegments.length < 3
            && $scope.params.TicketSearchSegments.filter((seg) => seg.DepartureAirport.length > 1).length === 0
            && $scope.params.TicketSearchSegments.filter((seg) => seg.ArrivalAirport.length > 1).length === 0;
    }

    function showBaggageFilter() {
        return $scope.params.ShowBaggageFilter;
    }

    function showEligibilityInfo() {
        return $scope.params.ShowEligibilityInfo;
    }

    function getMessage() {
        if ($scope.params.TicketSearchSegments.length > 2) {
            return l10nService.localize('Flexible option not available for itineraries over two segments');
        }
        return l10nService.localize('Flexible option not available for multiple departure/arrival airports');
    }
}



// WEBPACK FOOTER //
// ./src/app/modules/atc/controllers/atcCheckResultController.js